import React, { Component } from 'react';

// Graphql
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';


// Material UI Imports
import Avatar from '@material-ui/core/Avatar';
import List from '@material-ui/core/List';
import Snackbar from '@material-ui/core/Snackbar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';

// Material Icons Imports
import IconSocialPeople from '@material-ui/icons/People';
import IconActionDashboard from '@material-ui/icons/Dashboard';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

// Assets imports
import '../styles/ProjectDetail.css';

// Components Imports
import SmokeTest from './innerComponents/SmokeTest';
import AvatarItem from './innerComponents/AvatarItem';
import PRChecklist from './innerComponents/PRChecklist';
import DailyEntryDate from './innerComponents/DailyEntryDate';
import ProjectLogEntry from './innerComponents/ProjectLogEntry';
import ProjectBasicInfo from './innerComponents/ProjectBasicInfo';

// Lodash
import _ from 'lodash';
import { AppBar } from '@material-ui/core';

import { withStyles } from '@material-ui/core/styles';

// Import components
import CustomLoader from './innerComponents/CustomLoader';

const styles = theme => ({
  avatar: {
    size: 30,
    backgroundColor: theme.palette.primary.main,
    marginRight: 16
  },
  panelRoot: {
    marginTop: 16
  },
  panelSummary: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  panelHeading: {
    fontWeight: "500",
    fontSize: 15
  },
  tabsBar: {
    boxShadow: "none"
  }
});

class ProjectDetail extends Component {

  constructor(props) {
    super(props);
    this.state = {
      snackbarOpen: false,
      snackbarMessage: "message",
      showAddSupervisor: false,
      value: 0,
      refetched: false
    };
  }

  _handleRequestSnackbarOpen = (message) => {
    this.setState({
      snackbarOpen: true,
      snackbarMessage: message,
    });
  };

  _handleRequestSnackbarClose = () => {
    this.setState({
      snackbarOpen: false,
    });
  };

  _createProjectInvitation = async values => {
    // console.log(JSON.stringify(values, 0, 2));
    const supervisorId = values.supervisorId;
    const currentCreatedProjectId = values.projectId;
    this.props.projectInvitationMutation({
      variables: {
        currentCreatedProjectId,
        supervisorId
      }
    }).then(({ data }) => {
      this._handleRequestSnackbarOpen("The Supervisor " + data.createProjectInvitation.user.name + " has been notified, with the project invitation: " + data.createProjectInvitation.id);
    }).catch((error) => {
      this._handleRequestSnackbarOpen("Project Invitation Could not be created");
      console.log('There was an error sending the mutation: ', error);
    });
    this._handleClickEditSupervisors();
  }

  _handleClickEditSupervisors() {
    this.setState({
      showAddSupervisor: !this.state.showAddSupervisor
    });
  }

  _getSupervisorsList(currrent_project) {
    return currrent_project.projectInvitations !== null && currrent_project.projectInvitations.length > 0 ?
      currrent_project.projectInvitations.map((pi, id) =>
        <AvatarItem object={pi} type="customDateUser" key={id} />
      ) : <span>There are no Supervisors yet!</span>;
  }

  _getEnclosuresList(currrent_project) {
    return currrent_project.enclosures !== null && currrent_project.enclosures.length > 0 ?
      currrent_project.enclosures.map((enclosure, id) =>
        <AvatarItem object={enclosure} type="enclosure" key={id} />
      ) : <span>There are no Enclosures yet!</span>;
  }

  _getPRCList(currrent_project) {
    const prcsSorted = _.orderBy(currrent_project.postRemediationChecklists, ['date'], ['desc']);
    return prcsSorted !== null && currrent_project.postRemediationChecklists.length > 0 ?
      prcsSorted.map((prc, id) =>
        <PRChecklist prc={prc} key={id} initiallyExpanded={false} />
      ) : <span>There are no PRCs yet!</span>;
  }

  _getProjectLogEntries(currrent_project) {
    const plesSorted = _.orderBy(currrent_project.projectLogEntries, ['date'], ['desc']);
    return currrent_project.projectLogEntries !== null && currrent_project.projectLogEntries.length > 0 ?
      plesSorted.map((ple, id) =>
        <ProjectLogEntry ple={ple} key={id} initiallyExpanded={false} />
      ) : <span>There are no Project Log Entries yet!</span>;
  }

  _getSmoketestsList(currrent_project) {
    return currrent_project.smokeTests !== null && currrent_project.smokeTests.length > 0 ?
      currrent_project.smokeTests.map((smokeTest, id) =>
        <SmokeTest smokeTest={smokeTest} key={id} />
      ) : <span>There are no SmokeTests yet!</span>;
  }

  _getDailyEntriesList(currrent_project) {
    const dailyEntriesByDate = _.groupBy(
      _.map(currrent_project.dailyEntries,
        function (element) {
          return _.extend({}, element, { dateFormated: new Date(Date.parse(element.date)).toDateString() });
        }),
      "dateFormated"
    );
    // console.log(dailyEntriesByDate);
    return currrent_project.dailyEntries !== null && currrent_project.dailyEntries.length > 0 ?
      Object.keys(dailyEntriesByDate).map((dailyEntryDate, id) =>
        <DailyEntryDate dailyEntryDate={dailyEntryDate} dailyEntries={dailyEntriesByDate[dailyEntryDate]} key={id} initiallyExpanded={false} />
      ) : <span>There are no DailyEntries yet!</span>;
  }
  handleTabChange = (event, value) => {
    this.setState({ value });
  };

  componentDidMount() {
    if (this.props.refetch && !this.state.refetched) {
      this.props.all_supervisors_query.refetch()
        .then(this.props.detail_project_query.refetch())
        .then(this.setState({ refetched: true }))
    }
  }

  render() {
    const { classes } = this.props;


    // Check if the query response is being loaded
    if (this.props.detail_project_query && this.props.detail_project_query.loading) {
      return <CustomLoader label={'Loading'}/>
    }

    // Check if there were errrors
    if (this.props.detail_project_query && this.props.detail_project_query.error) {
      return <div>Error</div>
    }

    // Check if the query response is being loaded
    if (this.props.all_supervisors_query && this.props.all_supervisors_query.loading) {
      return <CustomLoader label={'Loading Supervisor'}/>
    }

    // Check if there were errrors
    if (this.props.all_supervisors_query && this.props.all_supervisors_query.error) {
      return <div> Supervisor Could not be loaded </div>
    }

    // Get the data to render it
    console.log("Name: " + this.props.detail_project_query.project.name);



    const currrent_project = this.props.detail_project_query.project;

    const { value } = this.state;

    return (
      <div className="ProjectDetail">
        <AppBar position="static" className={classes.tabsBar}>
          <Tabs value={value}
            onChange={this.handleTabChange}
            fullWidth
          >
            <Tab label="General Info" />

            <Tab label="Daily Entries" />

            <Tab label="Post Remediation Checklists" />

            <Tab label="Smoke Tests" />

            <Tab label="Project Log" />
          </Tabs>
        </AppBar>

        {value === 0 && <div>
          <ProjectBasicInfo project={currrent_project} />

          <ExpansionPanel className={classes.panelRoot}>
            <ExpansionPanelSummary
              expandIcon={<ExpandMoreIcon />}>
              <div className={classes.panelSummary}>
                <Avatar className={classes.avatar}><IconSocialPeople /></Avatar>
                <Typography className={classes.panelHeading}>Assigned Supervisors</Typography>
              </div>

            </ExpansionPanelSummary>
            <ExpansionPanelDetails >
              <div>
                <List>
                  {this._getSupervisorsList(currrent_project)}
                </List>
              </div>
            </ExpansionPanelDetails>
          </ExpansionPanel>

          <ExpansionPanel className={classes.panelRoot}>
            <ExpansionPanelSummary
              expandIcon={<ExpandMoreIcon />}>
              <div className={classes.panelSummary}>
                <Avatar className={classes.avatar}><IconActionDashboard /></Avatar>
                <Typography className={classes.panelHeading}>Enclosures</Typography>
              </div>

            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <div>
                <List>
                  {this._getEnclosuresList(currrent_project)}
                </List>
              </div>
            </ExpansionPanelDetails>
          </ExpansionPanel>
        </div>}

        {value === 1 && <div>
          {this._getDailyEntriesList(currrent_project)}
        </div>}

        {value === 2 && <div>
          {this._getPRCList(currrent_project)}
        </div>}

        {value === 3 && <div>
          {this._getSmoketestsList(currrent_project)}
        </div>}

        {value === 4 && <div>
          {this._getProjectLogEntries(currrent_project)}
        </div>}

        <Snackbar
          open={this.state.snackbarOpen}
          message={this.state.snackbarMessage}
          action="Close"
          onActionClick={this._handleRequestSnackbarClose}
          autoHideDuration={4000}
          onRequestClose={this._handleRequestSnackbarClose}
        />
      </div>
    );
  }
}

const PROJECT_QUERY = gql`
  query project_query($selectedId: ID!){
    project(id: $selectedId) {
      id
      endDate
      startDate
      siteAddress
      siteName
      location
      name
      number
      status
      creator{
        id
        fullName
      }
      insertedAt
      region{
        id
        name
      }
      supervisors{
        id
        name
        fullName
        role
        email
        active
      }
      enclosures{
        id
        name
      }

      projectInvitations(filters:[{field:"mark_as_deleted_eq",operand:"false"}]){
        id
        markAsDeleted
        user{
          id
          fullName
          role
          email
          active
        }
        inserted_at
      }

      projectLogEntries{
        comment
        date
        inserted_at
        device{
          user{
            fullName
            active
          }
        }
        images{
          id
          project{
            id
          }
          baseFileName
        }
      }

      postRemediationChecklists{
        id
        insertedAt
        date
        enclosure {
          id
          name
        }
        device{
          id
          type
          user{
            id
            name
            fullName
            active
          }
        }
        questionGroup{
          section
          questions{
            statement
            position
            comment
            id
            images{
              id
              description
              project{
                id
              }
            }
            answer
            type
          }
        }
      }
      smokeTests{
        nameOfWitness
        date
        time
        enclosure{
          id
          name
        }
        company
        id
      }
      dailyEntries{
        date
        id
        device{
          user{
            fullName
            name
            role
            active
          }
        }
        operatives{
          id
          name
          fullName
          active
        }
        negativePressureUnitChecks{
          id
          amReading
          pmReading
          negativePressureUnit{
            id
            serial
            nextRetestDate
          }
        }
        questionGroups{
          section
          device{
            id
            type
            user{
              id
              name
              fullName
              active
            }
          }
          questions{
            mandatory
            statement
            position
            comment
            id
            images{
              id
              description
            }
            answer
            type
          }
        }
      }

    }
  }
`;

const ALL_SUPERVISORS_QUERY = gql`
  query {
    users(filters: [{field: "active_eq" operand: "true"}, {field: "role_eq" operand: "Supervisor"}]){
      id
      fullName
      role
      email
    }
  }
`;

const submitProjectInvitation = gql`
  mutation createProjectInvitation($currentCreatedProjectId: ID!, $supervisorId: ID!){
    createProjectInvitation(input: {projectId: $currentCreatedProjectId, userId: $supervisorId, status: "SEND"}){
      id
      user{
        name
      }
    }
  }
`;

// Exporting the query
// export default graphql( PROJECT_QUERY, {
//   options: { variables: { "id": selected_id } }, }) (ProjectDetail)
//
export default compose(
  graphql(submitProjectInvitation, { name: 'projectInvitationMutation' }),
  graphql(ALL_SUPERVISORS_QUERY, { name: 'all_supervisors_query' }),
  graphql(PROJECT_QUERY, { name: 'detail_project_query' }, {
    options: ({ selectedId }) => ({ variables: { selectedId } }),
  })
)(withStyles(styles)(ProjectDetail));

// export default graphql(PROJECT_QUERY, {options: { variables: { id: 1 } },})(ProjectDetail);



// WEBPACK FOOTER //
// src/components/ProjectDetail.js